import { gql } from "apollo-boost";
import { fragments } from "../queries/JobContracts";

export default gql`
  mutation CreateContract($input: ContractInput!) {
    createContract(input: $input) {
      ...JobContractsContract
    }
  }
  ${fragments.Contract}
`;



// WEBPACK FOOTER //
// ./src/mutations/CreateContract.js